/** Erro como valor: código estável, mensagem legível e metadados. */
export interface Erro {
  codigo: string;
  mensagem: string;
  meta?: Record<string, unknown>;
}

export type Result<T> =
  | { ok: true; valor: T; erros?: undefined }
  | { ok: false; valor?: undefined; erros: Erro[] };

export const ok = <T>(valor: T): Result<T> => ({ ok: true, valor });
export const okVazio = (): Result<void> => ({ ok: true, valor: undefined });

export const fail = <T = never>(codigo: string, mensagem: string, meta?: Record<string, unknown>): Result<T> => ({
  ok: false,
  erros: [{ codigo, mensagem, ...(meta ? { meta } : {}) }],
});

export const failMuitos = <T = never>(erros: Erro[]): Result<T> => ({ ok: false, erros });

/** Junta vários Results; devolve todos os erros de uma vez. */
export function combinar<T extends Record<string, Result<unknown>>>(
  partes: T,
): Result<{ [K in keyof T]: T[K] extends Result<infer V> ? V : never }> {
  const erros: Erro[] = [];
  const valores: Record<string, unknown> = {};
  for (const [chave, r] of Object.entries(partes)) {
    if (r.ok) valores[chave] = r.valor;
    else erros.push(...r.erros.map((e) => ({ ...e, meta: { campo: chave, ...e.meta } })));
  }
  if (erros.length) return failMuitos(erros);
  return ok(valores as never);
}

/** Lança quando o Result falhou. Usado por `create` (variante que lança). */
export class ErroDominio extends Error {
  constructor(public readonly erros: Erro[]) {
    super(erros.map((e) => `${e.codigo}: ${e.mensagem}`).join('; '));
    this.name = 'ErroDominio';
  }
}

export function desembrulhar<T>(r: Result<T>): T {
  if (!r.ok) throw new ErroDominio(r.erros);
  return r.valor;
}
